import api from 'services/api';
import { enforce, runSchema } from 'validation';

import { schedulingWindowSchema, type SchedulingWindow } from './getSchedulingWindow';
import type { SaveSchedulingWindow } from './postSchedulingWindow';

/**
 * PUT `/scheduling_windows/:zone_name/:window_name` — update the window
 * identified by its **pre-edit** zone and name, which is how this resource is
 * addressed for writes even though the single read is by numeric id. A rename is
 * expressed by `save.name` differing from `windowName`.
 *
 * Both path segments are escaped: a name may contain a `/`, which would otherwise
 * 404 before reaching the route.
 *
 * Returns the updated window, validated against the shared
 * `schedulingWindowSchema` — the same `windowDetailsSQL()` shape as create and
 * read. Throws on HTTP error or structural validation failure.
 */
export const putSchedulingWindow = async (zoneName: string, windowName: string, save: SaveSchedulingWindow): Promise<SchedulingWindow> => {
  const res = await api.put(`/scheduling_windows/${encodeURIComponent(zoneName)}/${encodeURIComponent(windowName)}`, save);
  const r = runSchema(schedulingWindowSchema, res.data, 'putSchedulingWindow');
  if (!r.ok) {
    throw new Error('putSchedulingWindow: response failed validation');
  }
  return enforce(r.value, r.warnings, ['scheduling_window_id']);
};
